/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    // Send an AJAX request to update the cart note
    $(document).on('change', '#note', function() {
      var note = $(this).val();
      
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          note: note
        },
        dataType: 'json',
        success: function(cart) {
          Shopify.theme.jsAjaxCart.updateView();
        },
        error: function() {
          console.error('Failed to update cart note');
        }
      });
    });

    $(document)
  .off('click.ajaxAddToCart', '.ajax-submit')
  .on('click.ajaxAddToCart', '.ajax-submit', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $addToCartForm = $(this).closest('form');

    Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

    return false;
  });

$(document)
  .off('submit.ajaxAddToCart', 'form[action*="/cart/add"]')
  .on('submit.ajaxAddToCart', 'form[action*="/cart/add"]', function (e) {
    const $form = $(this);

    /*
     * Only handle forms that use Flex's AJAX add-to-cart button.
     */
    if (!$form.find('.ajax-submit').length) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    Shopify.theme.jsAjaxCart.addToCart($form);

    return false;
  });

    $(document)
  .off('click.ajaxCartDelete', '[data-ajax-cart-delete]')
  .on('click.ajaxCartDelete', '[data-ajax-cart-delete]', function (e) {
    e.preventDefault();

    const $cartItem = $(this).closest('[data-cart-item]');
    const cartItemKey = $cartItem.attr('data-cart-item');

    if (!cartItemKey) {
      console.error('Cart item key could not be found.');
      return false;
    }

    Shopify.theme.jsAjaxCart.removeFromCart(cartItemKey);

    return false;
  });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

    this.initializeQuantityHandler();

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').css('overflow', 'hidden');

  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').css('overflow', 'auto');
  },
  removeFromCart: function (cartItemKey, callback) {
  this.queueQuantityUpdate(cartItemKey, 0, callback);
},

/*
|--------------------------------------------------------------------------
| Custom Fix - July 2026
|--------------------------------------------------------------------------
|
| Fixes Shopify Buy X Get Y quantity bug in Flex AJAX cart.
|
| Shopify splits line items when automatic discounts apply, causing
| duplicate quantity updates and incorrect totals when editing quantities.
|
| This handler debounces manual entry and intercepts +/- buttons so only
| one cart/change.js request is sent.
|
| DO NOT REMOVE unless replacing with an equivalent implementation.
|
*/

initializeQuantityHandler: function () {
  const ajaxCart = this;

  if (ajaxCart.quantityHandlerInitialized) {
    return;
  }

  ajaxCart.quantityHandlerInitialized = true;
  ajaxCart.quantityUpdateQueue = {};
  ajaxCart.quantityUpdateTimers = {};
  ajaxCart.quantityRequestInProgress = false;

  function interceptQuantityEvent(event) {
    const input = event.target;

    if (!ajaxCart.isAjaxCartQuantityInput(input)) {
      return;
    }

    /*
     * Prevent Flex's existing delegated quantity handlers from
     * also submitting a cart request.
     */
    event.stopImmediatePropagation();

    /*
     * Commit when the browser fires a genuine change event.
     * Do not listen for blur because replacing the cart drawer HTML
     * also causes blur and creates a duplicate request.
     */
    if (event.type === 'change') {
      event.preventDefault();
      ajaxCart.scheduleQuantityUpdate(input, true);
      return;
    }

    if (event.type === 'keyup' && event.key === 'Enter') {
      event.preventDefault();
      ajaxCart.scheduleQuantityUpdate(input, true);
      return;
    }

    ajaxCart.scheduleQuantityUpdate(input, false);
  }

  document.addEventListener('input', interceptQuantityEvent, true);
  document.addEventListener('change', interceptQuantityEvent, true);
  document.addEventListener('keyup', interceptQuantityEvent, true);

  $(document)
  .off(
    'click.ajaxCartQuantityButton',
    '.ajax-cart__quantity-box [data-update-quantity]'
  )
  .on(
    'click.ajaxCartQuantityButton',
    '.ajax-cart__quantity-box [data-update-quantity]',
    function () {
      const $control = $(this);

      if ($control.is('[disabled]')) {
        return;
      }

      const $quantityBox = $control.closest('.ajax-cart__quantity-box');
      const input = $quantityBox.find('.quantity-input').get(0);

      if (!input) {
        return;
      }

      /*
       * Allow Flex's original plus/minus code to update the input first,
       * then send the resulting quantity to Shopify.
       */
      window.setTimeout(function () {
        if (!document.body.contains(input)) {
          return;
        }

        Shopify.theme.jsAjaxCart.scheduleQuantityUpdate(input, true);
      }, 150);
    }
  );
},

isAjaxCartQuantityInput: function (input) {
  if (!input || !input.matches) {
    return false;
  }

  /*
   * Do not depend on input type or name. Flex versions use different
   * markup, but the field is always inside the AJAX quantity box.
   */
  return Boolean(
    input.matches('.ajax-cart__quantity-box input') &&
    input.closest('#theme-ajax-cart')
  );
},

scheduleQuantityUpdate: function (input, submitImmediately) {
  const $input = $(input);

  if (!document.body.contains(input)) {
  return;
}

  const $cartItem = $input.closest('[data-cart-item]');
  const cartItemKey = $cartItem.attr('data-cart-item');

  if (!cartItemKey) {
    console.error('Cart item key could not be found for quantity update.');
    return;
  }

  let quantity = parseInt($input.val(), 10);
  const minimum = parseInt($input.attr('min'), 10);
  const maximum = parseInt($input.attr('max'), 10);

  /*
   * Do nothing while the field is temporarily empty as the customer
   * deletes the existing number.
   */
  if (!Number.isFinite(quantity)) {
    return;
  }

  quantity = Math.max(
    Number.isFinite(minimum) ? minimum : 0,
    quantity
  );

  if (Number.isFinite(maximum)) {
    quantity = Math.min(maximum, quantity);
  }

  $input.val(quantity);

  clearTimeout(this.quantityUpdateTimers[cartItemKey]);

  /*
   * Change, blur and Enter commit quickly. Normal typing waits until
   * the customer stops so "40" is never processed as "4" and "40".
   */
  const delay = submitImmediately ? 75 : 700;

  this.quantityUpdateTimers[cartItemKey] = setTimeout(function () {
  delete Shopify.theme.jsAjaxCart.quantityUpdateTimers[cartItemKey];

  if (!document.body.contains(input)) {
    return;
  }

  Shopify.theme.jsAjaxCart.queueQuantityUpdate(
    cartItemKey,
    quantity
  );
}, delay);
},

queueQuantityUpdate: function (cartItemKey, quantity, callback) {
  /*
   * Store only the newest requested quantity for each line. If the
   * customer enters 1, then 10, then 100, only 100 is processed.
   */
  this.quantityUpdateQueue[cartItemKey] = {
    quantity: quantity,
    callback: callback
  };

  this.processQuantityQueue();
},

processQuantityQueue: function () {
  const ajaxCart = this;

  if (ajaxCart.quantityRequestInProgress) {
    return;
  }

  const cartItemKeys = Object.keys(ajaxCart.quantityUpdateQueue);

  if (!cartItemKeys.length) {
    return;
  }

  const cartItemKey = cartItemKeys[0];
  const update = ajaxCart.quantityUpdateQueue[cartItemKey];

  delete ajaxCart.quantityUpdateQueue[cartItemKey];

  ajaxCart.quantityRequestInProgress = true;

  $('.ajax-cart__quantity-box input')
  .prop('readonly', true)
  .attr('aria-busy', 'true');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify({
      id: cartItemKey,
      quantity: update.quantity
    }),

    success: function (cart) {
      ajaxCart.updateView();

      if (typeof update.callback === 'function') {
        update.callback(cart);
      }
    },

    error: function (XMLHttpRequest) {
      let message = 'The cart quantity could not be updated.';

      try {
        const response = JSON.parse(XMLHttpRequest.responseText);

        message =
          response.description ||
          response.message ||
          message;
      } catch (error) {
        console.error('Unable to parse cart update error.', error);
      }

      console.error(message);

      /*
       * Reload the displayed cart so the input returns to Shopify's
       * actual quantity after a rejected update.
       */
      ajaxCart.updateView();
    },

    complete: function () {
  ajaxCart.quantityRequestInProgress = false;

  $('.ajax-cart__quantity-box input')
    .prop('readonly', false)
    .removeAttr('aria-busy');

  ajaxCart.processQuantityQueue();
}
  });
},
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = (response.message) ? response.message : response.description;
          
          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          
          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const total_price = options.total_price
        
        setTimeout(function() {
          $('.cartUpsellContainer .upsellInnerContainer').each(function () {
            const upsellId = $(this).attr('id').toString();
            let matched = false;
        
            $('.ajax-cart__list .ajax-cart__product').each(function () {
              const cartProdId = $(this).data('prod-id').toString();
        
              if (cartProdId === upsellId) {
                matched = true;
                return false; 
              }
            });
        
            if (matched) {
              $(this).addClass('added');
            } else {
              $(this).removeClass('added');
            }
          });
          $('.cartUpsellContainer').show();
          let upSellSliderElements = document.querySelectorAll('.cartUpsellContainer .cartUpsellProdBox');
          upSellSliderElements.forEach(function(upSellSliderElement) {
            if (upSellSliderElement && !$(upSellSliderElement).hasClass('flickity-enabled')) {
              let upSellSlider = new Flickity(upSellSliderElement, {
                accessibility: true,
                resize: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
                percentPosition: true,
                setGallerySize: true,
                cellAlign: 'left'
              });
        
              upSellSlider.on('settle', function () {
                upSellSlider.resize();
              });
        
              setTimeout(function () {
                upSellSlider.resize();
              }, 500);
            }
          });
        }, 1000);

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('.cartUpsellContainer').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        
        /* Update shipping indicator asynchronously js */
        if($('[data-fs-threshold]').length){
          let $parent = $('[data-fs-threshold]')
          let $remainingWrapper = $parent.find('.fs-indicator__remaining')
          let $successWrapper = $parent.find('.fs-indicator__success')
          
          let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
          if(fs_threshold >= total_price){
            //udpate
            let fs_remaining = fs_threshold - total_price;
            let fs_remaining_percent = total_price / fs_threshold * 100
            
            $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
            $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))
            
            $remainingWrapper.removeClass('is-hidden')
            $successWrapper.addClass('is-hidden')
          }else{
            //remove shipping indicator
            $remainingWrapper.addClass('is-hidden')
            $successWrapper.removeClass('is-hidden')
          }
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('.cartUpsellContainer').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }
      
      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;